import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-white" data-id="element-59">
      <div className="max-w-4xl mx-auto px-6" data-id="element-60">
        <FadeIn data-id="element-61">
          <div className="bg-holistic-sand/40 border-2 border-holistic-gold/30 rounded-3xl p-8 md:p-12 text-center relative" data-id="element-62">
            <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-white p-4 rounded-full shadow-lg border border-holistic-sand" data-id="element-63">
              <ShieldCheck size={48} className="text-holistic-gold" data-id="element-64" />
            </div>

            <h2 className="text-3xl font-serif text-holistic-earth mt-6 mb-4" data-id="element-65">
              Garantía "Sin Riesgos" de 7 Días
            </h2>
            <p className="text-lg text-holistic-earth-light leading-relaxed max-w-2xl mx-auto" data-id="element-66">
              Si en una semana sentís que este material no es para vos, te
              devolvemos el 100% de tu dinero.{' '}
              <strong className="text-holistic-earth" data-id="element-67">Sin vueltas.</strong>{' '}
              Queremos que entres con total seguridad de que este es el primer
              día de tu nueva vida.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}